import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import { CircularProgress, Grid2 as Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import { getCatalogResultSources } from "../../repositories/CatalogResultSourceRepository";
import { useCatalogResultSourceContext } from "./CatalogResultSourceContext";
import { TableResultSource } from "./components/TableResultSource";

type Props = {};
export const CatalogResultSourcePage = (props: Props) => {
	const { state, actions } = useCatalogResultSourceContext();
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");

	const getCatalogResultSourcesFromAPI = async () => {
		setIsLoading(true);
		const resp = await getCatalogResultSources();
		if (resp.ok) {
			actions.setResultSources(resp.data.tables[0].rows);
			setIsLoading(false);
		} else {
			setError(resp.message);
		}
	};

	useEffect(() => {
		getCatalogResultSourcesFromAPI();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	if (state.resultSources) {
		return (
			<>
				<HelmetDexteel title="Result Sources - Configurations" />
				<Grid container justifyContent="center" alignItems="center">
					<Grid size={{ xs: 12, md: 12 }} style={{ margin: 0 }}>
						<Paper
							elevation={0}
							style={{
								width: "100%",
								padding: "15px 20px 10px",
								borderRadius: "0.75rem",
							}}
						>
							<TableResultSource
								isLoading={isLoading}
								getCatalogResultSourcesFromAPI={getCatalogResultSourcesFromAPI}
							/>
						</Paper>
					</Grid>
				</Grid>
				<ErrorModal error={error} onHide={() => setError("")} />
			</>
		);
	}
	return (
		<Grid
			size={{ xs: 12 }}
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "70vh",
			}}
		>
			<CircularProgress />
		</Grid>
	);
};
